import RouterLink from 'ui-addon-react-router-dom/RouterLink';
const PLAYLIST_PATH = '/saved-items/playlists';
import UsageTracker from '../../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlaylistLink = ({
  playlistId,
  playlistName,
  position
}) => {
  const href = `${PLAYLIST_PATH}/${playlistId}`;
  const handleClick = () => {
    UsageTracker.track('interaction', {
      action: 'playlist-link-clicked',
      playlistId: playlistId.toString(),
      title: playlistName,
      to: href,
      position: position !== null && position !== void 0 ? position : undefined
    });
  };
  return /*#__PURE__*/_jsx(RouterLink, {
    onClick: handleClick,
    to: href,
    children: playlistName
  });
};
export default PlaylistLink;